export const iconFontAwesomeHandsHandSparkles = (
	<i className="fa-solid fa-hand-sparkles"></i>
);
